// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circulation-card {
  border-radius: 12px;
  background: #252525;
  max-width: 440px;
  overflow: hidden;
}

.circulation-card__image {
  position: relative;
}

.circulation-card__image img {
  display: block;
  width: 100%;
}

.circulation-card__game-count {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 0 48px 0 16px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  color: #FFFFFF;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}

.circulation-card__date {
  background: linear-gradient(90deg, rgba(255, 0, 9, 0.5) 0%, rgba(255, 0, 9, 0) 100%);
  padding: 10px 42px;
}

.circulation-card__date span {
  color: #FFFFFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.circulation-card__caption {
  display: flex;
  justify-content: space-between;
  padding: 16px;
}

.circulation-card__informations {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.circulation-card__information {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 112px;
}

.circulation-card__information span:nth-child(1) {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
}

.circulation-card__information span:nth-child(2) {
  color: #FFFFFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.circulation-card__information-blur {
  filter: blur(5px);
}

.circulation-card__buttons {
  display: flex;
  align-items: flex-end;
}

.circulation-card__link {
  border-radius: 8px;
  background: #FF0009;
  padding: 10px 28px;
  color: #F6F6F6;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.circulation-card__link:hover {
  color: #F6F6F6;
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/components/circulation-card/CirculationCard.scss","webpack://./src/modules/home/components/circulation-card/CirculationCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;ACClB;;ADCE;EACE,kBAAkB;ACEtB;;ADHG;EAGG,cAAc;EACd,WAAW;ACIjB;;ADAE;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,sBAAsB;EAEtB,4FAAc;EACd,cAAW;EACX,eAAY;EACZ,kBAAgB;EAChB,gBAAa;EACd,iBAAA;ACGH;;AAEA;EDQG,oFAAA;ECLD,kBAAkB;ADNjB;;ACSH;EDFM,cAAY;EACZ,eAAa;EACb,kBAAiB;EAClB,gBAAA;ECIH,iBAAiB;ADDjB;;ACIF;EAGE,aAAa;EDCX,8BAAsB;EACtB,aAAS;ACGb;;ADAE;EAGE,aAAQ;EAHT,sBAMC;EACE,SAAO;ACIb;;AAEA;EAGE,aAAa;EDAT,sBAAkB;EAClB,QAAA;EACA,gBAAa;ACKnB;;ADFI;EACE,+BAAiB;EAClB,eAAA;ECKH,kBAAkB;EDFlB,gBAAA;EACE,iBAAa;ACIjB;;AAEA;EDFE,cAAA;EACE,eAAe;EACf,kBAAY;EACZ,gBAAS;EACT,iBAAc;ACIlB;;AAEA;EDDI,iBAAiB;ACIrB;;ADbG;ECkBD,aAAa;EAGL,qBAAqB;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".circulation-card {\n  border-radius: 12px;\n  background: #252525;\n  max-width: 440px;\n  overflow: hidden;\n\n  &__image {\n    position: relative;\n    img {\n      display: block;\n      width: 100%;\n    }\n  }\n\n  &__game-count {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    padding: 0 48px 0 16px;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%);\n    color: #FFFFFF;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 32px;\n  }\n\n  &__date {\n    background: linear-gradient(90deg, rgba(255, 0, 9, 0.50) 0%, rgba(255, 0, 9, 0.00) 100%);\n    padding: 10px 42px;\n\n    span {\n      color: #FFFFFF;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 20px;\n    }\n  }\n\n  &__caption {\n    display: flex;\n    justify-content: space-between;\n    padding: 16px;\n  }\n\n  &__informations {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__information {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    max-width: 112px;\n\n    span:nth-child(1) {\n      color: rgba(255, 255, 255, 0.80);\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 21px;\n    }\n    span:nth-child(2) {\n      color: #FFFFFF;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 24px;\n    }\n\n    &-blur {\n      filter: blur(5px);\n    }\n  }\n\n  &__buttons {\n    display: flex;\n    align-items: flex-end;\n  }\n\n  &__link {\n    border-radius: 8px;\n    background: #FF0009;\n    padding: 10px 28px;\n    color: #F6F6F6;\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n\n    &:hover {\n      color: #F6F6F6;\n    }\n  }\n}",".circulation-card {\n  border-radius: 12px;\n  background: #252525;\n  max-width: 440px;\n  overflow: hidden;\n}\n\n.circulation-card__image {\n  position: relative;\n}\n\n.circulation-card__image img {\n  display: block;\n  width: 100%;\n}\n\n.circulation-card__game-count {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  padding: 0 48px 0 16px;\n  background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0.5)), to(rgba(255, 255, 255, 0)));\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);\n  color: #FFFFFF;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n}\n\n.circulation-card__date {\n  background: -webkit-gradient(linear, left top, right top, from(rgba(255, 0, 9, 0.5)), to(rgba(255, 0, 9, 0)));\n  background: linear-gradient(90deg, rgba(255, 0, 9, 0.5) 0%, rgba(255, 0, 9, 0) 100%);\n  padding: 10px 42px;\n}\n\n.circulation-card__date span {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.circulation-card__caption {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 16px;\n}\n\n.circulation-card__informations {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 12px;\n}\n\n.circulation-card__information {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 2px;\n  max-width: 112px;\n}\n\n.circulation-card__information span:nth-child(1) {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n.circulation-card__information span:nth-child(2) {\n  color: #FFFFFF;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.circulation-card__information-blur {\n  -webkit-filter: blur(5px);\n          filter: blur(5px);\n}\n\n.circulation-card__buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n\n.circulation-card__link {\n  border-radius: 8px;\n  background: #FF0009;\n  padding: 10px 28px;\n  color: #F6F6F6;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.circulation-card__link:hover {\n  color: #F6F6F6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
